import React, { FC } from 'react'

export const BunchDbPluginView: FC<IGridProps> = (props) => {
    return (
        <>

        </>
    )
}